import React from 'react';
import {
    Card,
    FormLayout,
    Checkbox,
    Select
} from '@shopify/polaris';
import { useState, useEffect } from 'react';
import {
    MetafieldTypeFormElement,
    MetafieldNamespaceAndKeyFormElement,
} from '../formElements/FormElements';
import { apiFetch as fetch } from '../../../../common/Helpers';

export function UpdateProductVariantMetafieldFromVariantOptionSettings(props) {

    const [optionNames, setOptionNames] = useState([]);

    useEffect(() => {

        fetch(`api/products/optionNames`, {
            method: "GET",
        }).then(response => response.json())
            .then(data => setOptionNames(data));
    }, []);

    const onSkipProductsWithSingleVariantChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.skipProductsWithSingleVariant = value;
        props.onSettingsChange(newSettings);
    }

    const onOptionNameChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.optionName = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>
            <Card.Section>
                <FormLayout>
                    <Select
                        label="Option Name"
                        placeholder='--- Select Option ---'
                        options={optionNames}
                        onChange={onOptionNameChange}
                        value={props.settings.optionName}
                        error={props.settingsErrors["optionName"]}
                        helpText={
                            <span>
                                Select the option that will be used as value for the metafield.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
            <Card.Section>
                <FormLayout>
                    <MetafieldNamespaceAndKeyFormElement
                        settings={props.settings}
                        settingsErrors={props.settingsErrors}
                        onChange={props.onSettingsChange} />
                    <MetafieldTypeFormElement
                        settings={props.settings}
                        settingsErrors={props.settingsErrors}
                        onChange={props.onSettingsChange} />
                </FormLayout>
            </Card.Section>
            <Card.Section title="Filtering">
                <FormLayout>
                    <Checkbox
                        label="Skip products with single variant"
                        checked={props.settings.skipProductsWithSingleVariant}
                        onChange={onSkipProductsWithSingleVariantChange}
                        helpText={
                            <span>
                                When checked, products with single variant will not be affected by this rule.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}